import React, { useState, useEffect } from 'react';
import Paginator from './Paginator/Paginator'
import TableItem from './TableItem/TableItem'
import { Table } from 'reactstrap';
import { useDebounce } from '../../services/debounce';

const DataTable = (props) => {
    const { onGetData, filters, search, columns, classes } = props;
    const [currPage, setCurrPage] = useState(0);
    const [data, setData] = useState({ page: props.data, totalRecords: (props.data ? props.data.length : 0) });
    const [expandedRows, setExpandedRows] = useState([]);

    const defaultColumnOptions = {
        header: undefined,
        sortable: false,
        searchable: false,
        filter: () => true,
        transform: (value) => value,
        template: null
    };

    const defaultRowOptions = {
        click: () => { },
        classes: []
    }

    let options = {
        key: null,
        pagination: { enabled: false },
        expand: { enabled: false },
        pageSize: 15,
        column: {},
        row: {},
        sizes: {},
        empty: "No items to display"
    };

    Object.assign(options, props.options);
    columns.forEach((key) => options.column[key] = Object.assign({ ...defaultColumnOptions }, options.column[key]));
    options.row = Object.assign({ ...defaultRowOptions }, options.row);

    const getData = async (filters, search, page, pageSize) => {
        var newdata = await onGetData(filters, search, page, pageSize);
        setData(newdata);
    }

    const getDataDebouncer = useDebounce(getData, 100, false, []);

    const reloadData = (page) => {
        getDataDebouncer(filters, search, page, options.pageSize);
        setCurrPage(page);
    };

    const handleExpandRow = rowId => {
        const currentExpandedRows = expandedRows;
        const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

        const newExpandedRows = isRowCurrentlyExpanded ?
            currentExpandedRows.filter(id => id !== rowId) :
            currentExpandedRows.concat(rowId);

        setExpandedRows(newExpandedRows);
    }

    const searchableColumns = columns
        .filter(key => options.column[key].searchable);

    let headers = columns.map((key, index) => <th
        className={options.column[key].classes ? options.column[key].classes.join(" ") : ""}
        style={{ width: options.column[key].width || options.sizes[key] }}
        key={index}>
        {options.column[key].header || key}
    </th>);

    //column filters
    let filteredData = ((data && data.page) || [])
        .filter(item => columns.every(key => options.column[key].filter(item[key])))

    //search filter
    if (searchableColumns.length > 0 && search && search.length > 0 && (options.pagination && !options.pagination.serverSide)) {
        const searchQuery = search.toLowerCase();
        filteredData = filteredData.filter(item => searchableColumns.some(key => (item[key] || "").toString().toLowerCase().includes(searchQuery)));
    }


    const numPages = Math.max(Math.ceil(((data && data.totalRecords) || (filteredData.length)) / options.pageSize), 1);


    //pagination slice
    if (options.pagination.enabled && !options.pagination.serverSide) {
        const dataStart = currPage * options.pageSize;
        filteredData = filteredData.slice(dataStart, dataStart + options.pageSize);
    }

    const rows = filteredData.map((item, index) => {
        const key = options.key ? item[options.key] : index;
        const onExpand = () => handleExpandRow(key);
        const expanded = expandedRows.includes(key);

        return <TableItem
            key={key}
            item={item}
            columns={columns}
            columnOptions={options.column}
            rowOptions={options.row}
            expandOptions={options.expand}
            onExpand={onExpand}
            expanded={expanded}
        />;
    });

    const pageChangeHandler = (nextPage) => {
        if (nextPage < 0 || nextPage >= numPages || nextPage === currPage)
            return;
        if (options.pagination.serverSide) reloadData(nextPage);
        else setCurrPage(nextPage);

    }

    useEffect(() => {
        onGetData && (async () => {
            var newdata = await onGetData(filters, search, 0, options.pageSize);
            setCurrPage(0);
            setData(newdata);
        })()
    }, [onGetData, filters, search, options.pageSize]);

    return (
        <div className="table-responsive">
            <Table hover className={classes ? classes.join(" ") : ""}>
                <thead className="thead-light">
                    <tr>
                        {headers}
                    </tr>
                </thead>
                <tbody>
                    {rows.length > 0 ? rows : <tr><td colSpan="999"><p>{options.empty}</p></td></tr>}
                </tbody>
            </Table>
            { options.pagination.enabled ? <Paginator page={currPage} change={pageChangeHandler} total={numPages} /> : null}
        </div>
    );
}

export default DataTable;